export enum FilterName {
  FreeText = 'freeText',
  MatchPeriod = 'matchPeriod',
  Season = 'seasons',
  Competition = 'competitions',
  Matchdays = 'matchdays',
  IsTrackingAvailable = 'isTrackingAvailable',
  Incidence = 'filterIncidence',
}
